import React from 'react'
import { VStack } from '@/src/views/parts/bases/VStack'
import { Text } from '@/src/views/parts/bases/Text'
import { HStack } from '@/src/views/parts/bases/HStack'
import { ArcadeMachineCard } from '@/src/views/parts/nft/ArcadeMachineCard'
import { NftState } from '@/src/graphql/generated/types'

export type Props = {
  items: Array<{
    imageUrl: string
    id: string
    name: string
    state?: NftState
    onClick?: () => void
    energy?: number
    maxEnergy?: number
    extractedEnergy?: number
    installable?: boolean
    extractable?: boolean
    dismantable?: boolean
    feverSparkRemain: number | null
  }>
  maxArcadeMachineCounts: number
}

export const Layout = (props: Props) => {
  return (
    <VStack className="w-full p-8">
      <HStack className="mb-6 items-baseline">
        <h1 className="text-3xl font-bold text-white" style={{ textShadow: '#805BE7 1px 0 20px' }}>
          ArcadeMachine
        </h1>
        <Text className="ml-4 text-lg font-bold text-gray-500">({props.maxArcadeMachineCounts})</Text>
      </HStack>
      <div className="flex flex-row flex-wrap gap-6">
        {props.items.map((item) => (
          <ArcadeMachineCard key={item.id} cardSize="L" {...item} />
        ))}
      </div>
    </VStack>
  )
}
